import React, {useState, useEffect} from "react";
import EditablePdf from "../../../components/forms/EditablePdf";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import SessionGenerator from "./sessions/SessionGenerator";
import {Input, Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton, ResetButton} from "../../../styles/Butttons";
import nextId from "react-id-generator";
import MediaCreator from "./media/MediaCreator";
import {CreateResourceCourse} from "../../../services/GeneralServices";
import AppLoader from "../../../components/loaders/Loader";

const FormPartTwo = React.forwardRef((props, ref) => {
   const [newPdf, setPdf] = useState({file: "", name: ""});
   const [isSaving, setSavin] = useState(false);

   const savePdf = () => {
      if (!newPdf.file) {
         return props.continue();
      }
      setSavin(true);
      let newData = new FormData();
      newData.append("idCourse", props.idCourse);
      newData.append("resourceName", newPdf.name || "PDF del curso");
      newData.append("token", localStorage.getItem("domecq_token"));
      newData.append("pathResource", newPdf.file.files[0]);

      CreateResourceCourse(newData)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            props.continue();
            setSavin(false);
            console.log(resp);
         })
         .catch((e) => {
            props.continue();
            setSavin(false);
            console.log(e);
         });
   };
   return (
      <>
         <AllGrid>
            <Col large={12}>
               <TitleSecion>Descargable y vídeos:</TitleSecion>
            </Col>
            <Col>
               <Grid>
                  <Label>Recurso PDF descargable:</Label>
                  <MediaCol large={6}>
                     <Input placeholder="Nombre del archivo" onChange={(e) => setPdf({...newPdf, name: e.target.value})} />
                     <EditablePdf change={(e) => setPdf({...newPdf, file: e.target})} editable={true} name="resoursePdf" />
                  </MediaCol>
               </Grid>
            </Col>
            {/* <AppButton onClick={savePdf}>Guarar</AppButton> */}
            <MediaCreator idCourse={props.idCourse} savePdf={savePdf} />
         </AllGrid>
         <AppLoader isVisible={isSaving} />
      </>
   );
});

export default FormPartTwo;

const AllGrid = styled(Grid)`
   .sepTop {
      margin-top: 2em;
   }
`;

const TitleSecion = styled.p`
   font-size: 1.5em;
   font-weight: 400;
   color: #1c355e;
   margin: 1em 0 1.5em 0;
`;

const MediaCol = styled(Col)`
   display: flex;
   align-items: flex-end;

   & ${ResetButton} {
      width: auto;
      padding: 0.3em 0.5em;
      height: fit-content;
      color: crimson;
   }

   .row {
      width: 90%;
   }

   &.sepTop {
      margin-top: 1em;
   }
`;

const Title = styled.p``;

const ClasesText = styled.textarea`
   font-size: 1em;
   font-family: Montserrat;
   resize: none;
   width: 100%;
   height: 120px;
   margin: 0.5em 0;
`;
